import * as ReactDOM from "react-dom/client";
import { App } from "./App";
import { BrowserRouter as Router } from "react-router-dom";

import "./styles/index.css";
import { DataProvider } from "providers/DataProvider";
import { SoundProvider } from "providers/SoundProvider";
import { ChakraProvider } from "@chakra-ui/react";
import { HelmetProvider } from "react-helmet-async";

import theme from "styles/theme";

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

root.render(
  <ChakraProvider theme={theme}>
    <Router>
      <SoundProvider>
        <DataProvider>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </DataProvider>
      </SoundProvider>
    </Router>
  </ChakraProvider>
);
